<template lang="html">
  <div class="draw-path">
    <DrawPathSetting></DrawPathSetting>
  </div>
</template>

<script>
import DrawPathSetting from './draw-path-setting.vue';

export default {
  components: {
    DrawPathSetting
  }
};
</script>

<style lang="scss" scoped>
.draw-path{
  height: 100%;
}
</style>
